import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { NonWorkspacePage, PageEmptyState } from "../components/layout/NonWorkspacePage";

/** Catch-all route: a bad link must say so instead of rendering a blank page. */
export function NotFound() {
  const location = useLocation();
  useEffect(() => {
    document.title = "Page not found — HelloConvo";
  }, []);
  return (
    <NonWorkspacePage
      width="standard"
      header={{
        eyebrow: "Not found",
        title: "Page not found",
        description: "This link does not point to a page in HelloConvo.",
        breadcrumbs: [{ label: "Workspace", href: "/home" }, { label: "Not found" }],
      }}
    >
      <PageEmptyState
        title="We couldn't find that page"
        description={<>Nothing lives at <code className="break-all">{location.pathname}</code>. It may have moved, or the link may be mistyped.</>}
        action={<Link className="font-medium text-brand-700 underline" to="/home">Go to Workspace</Link>}
      />
    </NonWorkspacePage>
  );
}
